<div class="e-button-bar">
    <button (click)="buttonClicked()" [attr.disabled]="buttonDisabled ? true : null">
        {{buttonLabel}}
        <i class="{{iconClass}}"></i>
    </button>
</div>
